import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DropdownOptions from "../../../constants/DropdownOptions";
import { deleteTruckAction, editTruckAction, trucklineListAction } from "../../../modules/truckline/action";
import AllMainFarmSelectedDialog from "../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import TabHeaderAndButton from "../../Common/TabHeaderAndButton";
import CreateTable from "../../CreateTable";
import ConfirmationDialog from "../../FormElement/ConfirmationDialog";
import Loader from "../../Loader";


class TrucklinesView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      headerRows: {
        updatedAt: "Last Updated",
        updatedBy: "Updated By",
        type: "Type",
        name: "Name of the Truck",
        contact: "Contact Phone Number",
        address: "Address",
        comment: "Extra Comments"
      },
      order: "desc",
      orderBy: "id",
      open: false
    };
  }

  componentDidMount() {
    const { trucklineListAction, selectedYear } = this.props;
    if(!isSuperAdmin() || this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
      trucklineListAction(selectedYear);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.rowData &&
      this.props.rowData !== nextProps.rowData &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    if (this.props.MainFarmId !== nextProps.MainFarmId &&
      nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
        this.props.trucklineListAction(this.props.selectedYear);
      }
    if (nextProps.selectedYear && nextProps.selectedYear !== this.props.selectedYear &&
      (!isSuperAdmin() || nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id)) {
      this.props.trucklineListAction(nextProps.selectedYear);
    }
  }

  deleteRow = id => {
    this.setState({
      open: true,
      id: id
    });
  };

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleOk = () => {
    const { id } = this.state;
    this.handleClose();
    this.props.deleteTruckAction(id);
  };

  editRow = id => {
    const { rowData } = this.props;
    const requiredData = rowData.find(truckline => truckline.id === id);
    this.props.editTruckAction(requiredData);
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  render() {
    const { rowData } = this.props;
    const { fetchingComplete, order, orderBy, open } = this.state;
    const prevPath = "farmsetup",
      currentPage = "/trucklines";
    return (
      <div className="ticket-body">
        <ConfirmationDialog
          open={open}
          handleClose={this.handleClose}
          handleOk={this.handleOk}
        />
        <TabHeaderAndButton
          header="Trucklines"
          path={`/${prevPath}${currentPage}/create`}
          btnLabel="New truck"
          isDisabled={isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id}
        />
        {isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? 
        (<AllMainFarmSelectedDialog/>) : 
        (
          <div>
            {fetchingComplete ? (
              <CreateTable
                order={order}
                orderBy={orderBy}
                headerRows={this.state.headerRows}
                rowData={rowData}
                delete={this.deleteRow}
                location={`${prevPath}${currentPage}/edit`}
                edit={this.editRow}
                onRequestSort={this.handleRequestSort}
              />
            ) : (
              <Loader />
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rowData: state.trucklineReducer.trucksList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { trucklineListAction, deleteTruckAction, editTruckAction },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrucklinesView);



// WEBPACK FOOTER //
// ./src/components/private/Trucklines/TrucklinesView.js